angular.module('app.ctrls').directive('sticky', [
    '$window',
    function ($window) {
        return {
            restrict: 'A',
            scope: {
                stickyElementId: '@'
            },
            link: function (scope, element, attrs) {
                var $stickyElement = angular.element('#' + scope.stickyElementId);

                $stickyElement.bind('scroll', function () {
                    var $element = $(element);
                    var options = options || {};
                    options.padding = options.padding || 0;

                    var scrollTop = $stickyElement.scrollTop();
                    $element.css('margin-top', scrollTop + options.padding);
                });
            }
        };
    }
]);
